import { Injectable } from '@angular/core';

// the micro scale the API and chaincode round every weight to
// (realmeds/network/api/lib/constants.js -> weight.DECIMALS)
const WEIGHT_DECIMALS = 6;

@Injectable()

export class Utils {
    constructor() { }

    getObject(key, value, array) {
        let obj = null;
        if (array) {
            obj = array.find((item) => {
                return item[key] == value;
            });
        } 
        return obj;
    }

    getIdx(key, value, array) {
        let obj = null;
        if (array) {
          var ln = array.length;
          for (var i = 0; i < ln; i++) {
            if (array[i][key] == value) {
              return i;
            }
          }
        }
        return -1;
    }

    // remove object from array based on attribute and value
    removeByAttr(arr, attr, value) {
      var i = arr.length;
      while (i--) {
        if (
          arr[i] &&
          arr[i].hasOwnProperty(attr) &&
          arguments.length > 2 &&
          arr[i][attr] === value
        ) {
          arr.splice(i, 1);
        }
      }
      return arr;
    }

    /**
     * Gross weight for an operator who works from tare + net. Only gross and
     * tare are ever persisted - every tier re-derives net as gross - tare - so
     * gross has to be the exact sum at the scale those tiers round to. Rounding
     * here is what makes the net that gets printed equal the net that was typed.
     *
     * @returns null when either operand is blank or not a number
     */
    grossFromTareAndNet(tare, net): number {
      if (tare === null || tare === undefined || String(tare).length === 0
        || net === null || net === undefined || String(net).length === 0) {
        return null;
      }
      const sum = Number(tare) + Number(net);
      return isFinite(sum) ? Number(sum.toFixed(WEIGHT_DECIMALS)) : null;
    }

    /**
     * A.R. No and storage condition are batch level facts, but they are stored
     * on each label's metadata rather than on the batch, so the only way to
     * recover them is to read them back off the labels already issued. Voided
     * labels are skipped and later labels win, so a correction made by a void &
     * reissue is what gets carried forward.
     *
     * @param instances bulk instances as returned by Batches/bulkInstance
     * @param fields metadata fields to recover
     * @returns only the fields that were actually found, for a partial patchValue
     */
    getBulkLabelDefaults(instances: any[], fields: string[]) {
      const defaults = {};
      if (!instances || !instances.length) {
        return defaults;
      }
      instances
        .filter((it) => it && !it.cancelled && it.metadata)
        .forEach((it) => {
          fields.forEach((field) => {
            const value = it.metadata[field];
            if (value !== undefined && value !== null && String(value).length > 0) {
              defaults[field] = value;
            }
          });
        });
      return defaults;
    }

    /**
     *
     * @param dateStr
     * @returns timezone value
     */
    getTimeZoneFromDateString(dateStr: string) {
      let zoneTypeIdx = dateStr.indexOf("+") > 0 ? dateStr.indexOf("+") : dateStr.lastIndexOf("-");
      return dateStr.slice(zoneTypeIdx, dateStr.length);
    }
}